import React from 'react';
import ReactDOM from 'react-dom/client';
import Unsorted from './Unsorted';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<Unsorted />
	</React.StrictMode>
);